// @ts-strict-ignore
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { TAccessoryPageData, TBurgerLevel1, TError, TSection } from '@/shared/types/deprecated-types'

type InitialStateProps = {
	items: TSection[]
	accessories: TAccessoryPageData
	burger: TBurgerLevel1[]
	error: TError
	isLoading: boolean
}

const initialState = {
	items: [],
	burger: [],
	accessories: {},
	error: {
		status: false,
		code: null,
		message: ``
	},
	isLoading: false
} as InitialStateProps

const categories = createSlice({
	name: `categories`,
	initialState,
	reducers: {
		setCategories: (state: InitialStateProps, action: PayloadAction<TSection[]>) => {
			state.isLoading = false
			state.items = action.payload
		},
		requestBurgerMenuCategoriesSuccess: (state: InitialStateProps, action: PayloadAction<TBurgerLevel1[]>) => {
			Object.entries(action.payload).forEach(([filedName, fieldValue]) => {
				state.burger[filedName] = fieldValue
			})
		},
		setAccessories: (state: InitialStateProps, action: PayloadAction<TAccessoryPageData>) => {
			state.accessories = action.payload
		}
	}
})

export const { setCategories, requestBurgerMenuCategoriesSuccess, setAccessories } = categories.actions
export default categories.reducer
